/*
 * @Author: Zhouqi
 * @Date: 2025-12-15 10:07:40
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-03-30 10:11:05
 */
export const GUANCEYUN_VERSION = '1.7';
export const APP_VERSION = '3.8';
